import { Model } from '@vuex-orm/core';
import http from '@/services/http';

export default class OrderProviderStoreService extends Model {
  static entity = 'orderProviderStoreServices';

  static primaryKey = 'id';

  // FIELDS //////////////////////
  static fields() {
    return {
      id: this.attr(null),
      storeId: this.attr(null),
      orderProviderServiceId: this.attr(null),
      menuTypeId: this.attr(null),
      orderProviderLocationId: this.attr(''),
      orderProviderMenuId: this.attr(''),
      orderProviderType: this.attr(''),
      salesTaxRate: this.attr(null),
      alcoholSalesTaxRate: this.attr(null),
      isActive: this.attr(false)
    };
  }

  // STATE //////////////////////
  static state() {
    return {
      fetching: false,
      creating: false,
      updating: false,
      deleting: false
    };
  }

  static $state() {
    return this.store().state.entities.orderProviderStoreServices;
  }

  // ACTIONS //////////////////////
  static async fetchStoreServices(storeId) {
    try {
      this.commit((state) => {
        state.fetching = true;
      });

      const { data } = await http.get(`stores/${storeId}/order_provider_store_services`);

      this.insert({ data: data.orderProviderStoreServices });

      return data;
    }
    catch (error) {
      throw error;
    }
    finally {
      this.commit((state) => {
        state.fetching = false;
      });
    }
  }

  static async fetchStoreService(id) {
    try {
      this.commit((state) => {
        state.fetching = true;
      });

      const { data } = await http.get(`order_provider_store_services/${id}`);

      this.insert({ data: data.orderProviderStoreService });

      return data;
    }
    catch (error) {
      throw error;
    }
    finally {
      this.commit((state) => {
        state.fetching = false;
      });
    }
  }

  static async createStoreService(storeId, storeService) {
    try {
      this.commit((state) => {
        state.creating = true;
      });

      const { data } = await http.post(`stores/${storeId}/order_provider_store_services`, {
        order_provider_store_service: storeService
      });

      this.insert({ data: data.orderProviderStoreService });

      return data;
    }
    catch (error) {
      throw error;
    }
    finally {
      this.commit((state) => {
        state.creating = false;
      });
    }
  }

  static async updateStoreService(storeService) {
    try {
      this.commit((state) => {
        state.updating = true;
      });

      const { data } = await http.put(`order_provider_store_services/${storeService.id}`, {
        order_provider_store_service: storeService
      });

      return this.update({
        where: storeService.id,
        data: data.orderProviderStoreService
      });
    }
    catch (error) {
      throw error;
    }
    finally {
      this.commit((state) => {
        state.updating = false;
      });
    }
  }

  static async deleteStoreService(id) {
    try {
      this.commit((state) => {
        state.deleting = true;
      });

      await http.delete(`order_provider_store_services/${id}`);

      return this.delete(id);
    }
    catch (error) {
      throw error;
    }
    finally {
      this.commit((state) => {
        state.deleting = false;
      });
    }
  }
}
